import { Link } from 'react-router-dom';

import styles from '../../../../styles/Admin.module.scss';

function Item({ _id, firstName, lastName, email, isActive, admin, onToggle, loading }) {
	const status = isActive ? 'Active' : 'Awaiting activation';
	const rowClass = `${!isActive ? styles.disabledRow : ''} ${admin ? styles.adminRow : ''}`.trim();

	return (
		<tr className={rowClass}>
			<td>
				<Link to={_id} className={styles.tableLink}>
					{`${firstName} ${lastName} (${email})`}
				</Link>
			</td>
			<td>{admin ? 'Admin' : status}</td>
			<td className={styles.tableActions}>
				{!admin && (
					<button
						type="button"
						className={isActive ? "btn btnDanger" : "btn btnPrimary"}
						onClick={() => onToggle(_id, !isActive)}
						disabled={loading}
					>
						{loading ? 'Updating...' : isActive ? 'Deactivate' : 'Activate'}
					</button>
				)}
			</td>
		</tr>
	)
}

export default Item;
